/** Find a product in the catalog object by category slug + external id. */
import { normalizeProductJewelryOptions } from '../jewelry/jewelryCustomization';

export function findProductInCatalog(products, categorySlug, productId) {
  const cat = String(categorySlug || '').trim();
  const id = String(productId || '').trim();
  if (!cat || !id) return null;
  const list = products?.[cat];
  if (!Array.isArray(list)) return null;
  const hit = list.find((p) => String(p?.id || '').trim() === id);
  if (!hit) return null;
  const customization_options = normalizeProductJewelryOptions({
    customization_profile: hit.customization_profile,
    customization_options: hit.customization_options,
  });
  return { ...hit, category: cat, customization_options };
}
